import type { paths } from '@orlikfy/api-interfaces';

export type {
  CommonGameDto,
  CoordinatesDto,
  HostDto,
  LocationGamesDto,
  NearbyGamesByLocationDto,
  NearbyGamesByLocationDtoLocation,
  NearbyGamesListDto
} from '@orlikfy/api-interfaces';

// GET /nearby-games/locations
export const GET_NEARBY_GAMES_LOCATIONS_PATH = '/nearby-games/locations' as const satisfies keyof paths;
type GetNearbyGamesLocationsOperation = paths[typeof GET_NEARBY_GAMES_LOCATIONS_PATH]['get'];
export type GetNearbyGamesLocationsResponse =
  GetNearbyGamesLocationsOperation['responses'][200]['content']['application/json'];

// GET /nearby-games/list
export const GET_NEARBY_GAMES_LIST_PATH = '/nearby-games/list' as const satisfies keyof paths;
type GetNearbyGamesListOperation = paths[typeof GET_NEARBY_GAMES_LIST_PATH]['get'];
export type GetNearbyGamesListResponse = GetNearbyGamesListOperation['responses'][200]['content']['application/json'];

// GET /location/{locationId}/games
export const GET_LOCATION_GAMES_PATH = '/location/{locationId}/games' as const satisfies keyof paths;
type GetLocationGamesOperation = paths[typeof GET_LOCATION_GAMES_PATH]['get'];
export type GetLocationGamesPathParams = GetLocationGamesOperation['parameters']['path'];
export type GetLocationGamesResponse = GetLocationGamesOperation['responses'][200]['content']['application/json'];
